module.exports = __webpack_public_path__ + "static/media/11@960w.d3b86539.jpg";